import React from "react";
import { Navigate } from "react-router-dom";

const ParentProtectedRoute = ({ children }) => {
  const token = sessionStorage.getItem("parentToken") || localStorage.getItem("parentToken");
  if (!token) return <Navigate to="/parent/login" replace />;
  return children;
};

export default ParentProtectedRoute;
